import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ImpersonationService } from 'app/core/impersonation/impersonation.service';

/**
 * @description
 * Banner global fijo que indica que el super_admin está viendo el panel como otro
 * usuario (impersonation). Visible mientras `isImpersonating$` sea true; ofrece el
 * botón para salir y volver a la identidad original. Se monta en `app.component`.
 */
@Component({
    selector: 'impersonation-banner',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [AsyncPipe, MatButtonModule, MatIconModule, TranslocoPipe],
    template: `
        @if (user$ | async; as u) {
            <div
                class="fixed left-1/2 top-2 z-[9999] flex max-w-[92vw] -translate-x-1/2 items-center gap-2 rounded-full bg-amber-500 py-1 pl-3 pr-1 text-sm font-medium text-black shadow-lg ring-1 ring-amber-600/40"
                role="status"
                aria-live="polite">
                <mat-icon class="icon-size-4 shrink-0 text-black" fontSet="fa" fontIcon="fa-user-secret"></mat-icon>
                <span class="truncate">
                    {{ 'IMPERSONATION.VIEWING_AS' | transloco }}
                    <b>{{ u.firstname }} {{ u.lastname }}</b>
                </span>
                <button mat-flat-button class="ml-1 h-7 min-h-7 shrink-0 rounded-full bg-black px-3 leading-7 text-white" [attr.aria-label]="'IMPERSONATION.EXIT' | transloco" (click)="stop()">
                    <mat-icon class="icon-size-4 mr-1 text-white" fontSet="fa" fontIcon="fa-right-from-bracket"></mat-icon>
                    {{ 'IMPERSONATION.EXIT' | transloco }}
                </button>
            </div>
        }
    `,
})
export class ImpersonationBannerComponent {
    private _impersonation = inject(ImpersonationService);

    /** Datos del usuario impersonado; null ⇔ no hay impersonation activa (controla el banner). */
    user$ = this._impersonation.impersonatedUser$;

    /** Sale de la impersonation y restaura al super_admin (recarga la app). */
    stop(): void {
        this._impersonation.stopImpersonation();
    }
}
